var styles = {"tend-ui-form-field-root":"tend-ui-form-field-root"};

export { styles as default };
